import axios, { AxiosRequestHeaders } from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.xdos.uk';

export type EventRuntimeResponse = {
  eventId: string;
  name: string;
  gameType: string;
  gamePeriod: number;
  maxGamePeriods: number;
  inPlay: boolean;
  periodStatus?: 'ready' | 'running' | 'ended';
  timer: {
    startedAt: number | null;
    accumulatedMs: number;
    running: boolean;
  };
  permissions: {
    canControlTimer: boolean;
    canViewTimer: boolean;
  };
  log: {
    ts: number;
    action: string;
    actorUserId?: string;
    actorRole?: string | null;
    note?: string;
  }[];
};

function authHeaders(): AxiosRequestHeaders {
  const token = localStorage.getItem('token');

  if (!token) {
    return {};
  }

  return {
    Authorization: `Bearer ${token}`,
  };
}

export async function getEventRuntime(eventId: string): Promise<EventRuntimeResponse> {
  const { data } = await axios.get(`${API_URL}/events/${eventId}/runtime`, {
    headers: authHeaders(),
  });

  return data;
}

export async function startEvent(eventId: string): Promise<EventRuntimeResponse> {
  const { data } = await axios.post(
    `${API_URL}/events/${eventId}/start`,
    {},
    {
      headers: authHeaders(),
    },
  );

  return data;
}

export async function endEvent(eventId: string): Promise<EventRuntimeResponse> {
  const { data } = await axios.post(
    `${API_URL}/events/${eventId}/end`,
    {},
    {
      headers: authHeaders(),
    },
  );

  return data;
}